export default __webpack_public_path__ + "locales/ko-KR/Ldap.json?hash=c5ca7c34cd11af6f5c2445f910b5e993";